import type { ProgramInterface } from '../../types/program.interface';
import { StarRating } from '@beholos/holoscommon';

interface Props {
  program: ProgramInterface;
  rating: number;
  selectRating: (rating: number) => void;
  review: string;
  message: string;
  onChangeReview: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleCreateReview: () => void;
}

export const ProgramCompleteModal = ({
  program,
  rating,
  selectRating,
  review,
  onChangeReview,
  message,
  handleCreateReview,
}: Props) => {
  const shareText =
    'Completé este programa de entrenamiento con Holos. ¡Me encantó! Te invito a probarlo registrándote aquí: contacto@beholos.com';

  return (
    <div className="bg-white rounded-xl overflow-hidden max-w-xl mx-auto text-center">
      <div className="bg-gray-100 px-8 py-6">
        <h2 className="text-2xl font-bold mb-4">¡Felicidades! Haz completado este programa</h2>
        <h4 className="text-lg font-semibold">Cuéntanos qué te pareció</h4>
        <div className="text-xs text-gray-600 mb-2">
          Has recibido 50 HoloPoints por completar este programa. ¡Deja un comentario completo y gana 5 extra HoloPoints!
        </div>

        <StarRating
          rating={rating}
          onRatingChange={selectRating}
          size={34}
          className="justify-center mb-4"
        />

        <div className="mb-4">
          <textarea
            maxLength={300}
            value={review}
            onChange={onChangeReview}
            className="w-full p-2 border rounded resize-none"
            rows={4}
            placeholder="Escribe tu opinión..."
          />
          <div className="text-right text-sm mt-1">
            <span className={review.length === 300 ? 'text-red-500' : ''}>
              {300 - review.length} caracteres restantes
            </span>
          </div>
        </div>

        <button
          onClick={handleCreateReview}
          className="bg-holos-dark text-white py-2 px-4 rounded w-full cursor-pointer font-semibold"
        >
          Listo!
        </button>

        <div className="border-b border-gray-400 my-8" />

        <a
          href={`https://api.whatsapp.com/send?text=Hola!%20Como%20lo%20bueno%20se%20comparte%2C%20te%20invito%20a%20hacer%20este%20programa%20GRATIS%20para%20que%20empieces%20%23contodo.%20Yo%20lo%20complet%C3%A9%20y%20me%20encant%C3%B3!%20Escribe%20a%20contacto%40beholos.com%20y%20pide%20tu%20membres%C3%ADa%20BASIC%20gratis%20x%20un%20mes%20tan%20solo%20dando%20mi%20nombre`}
          target="_blank"
          rel="noopener noreferrer"
          className="border-2 border-green-500 text-black py-2 px-4 rounded w-full block text-sm font-semibold mb-2 flex justify-center items-center"
        >
          <img src="https://cache.beholos.com/img/holos/general/brands/whatsapp.svg" alt="WhatsApp Icon" className="w-5 h-5 mr-2" />
          Invita a un amigo a este programa
        </a>

        <div className="text-xs text-gray-500 mb-2">o comparte este logro</div>

        <div className="flex justify-center space-x-6 text-2xl text-black">
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=https://www.beholos.com/programas/${program.slug}&quote=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://cache.beholos.com/img/holos/general/brands/facebook.svg" alt="Facebook Icon" className="w-9 h-9 mb-1" />
          </a>
          <a
            href={`https://x.com/intent/tweet?text=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://cache.beholos.com/img/holos/general/brands/x.svg" alt="X Icon" className="w-9 h-9 mb-1" />
          </a>
          <a
            href={`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://cache.beholos.com/img/holos/general/brands/whatsapp.svg" alt="WhatsApp Icon" className="w-9 h-9 mb-1" />
          </a>
        </div>
        {message.length > 0 && (
          <p className="text-black font-semibold text-sm mb-4">{message}</p>
        )}
      </div>
    </div>
  );
};